<script src="https://www.google.com/recaptcha/api.js"></script>

<template>
  <div>
    <div class="text-center" v-if="loading">
      <b-spinner class="ms-2" variant="primary"></b-spinner>
    </div>
    <div class="account-pages my-5 pt-5" v-else>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-8">
            <div class="card overflow-hidden">
              <div class="bg-soft-primary">
                <div class="row">
                  <div class="col-8">
                    <div class="text-primary p-4">
                      <h5 class="text-primary">Redefinir Senha</h5>
                    </div>
                  </div>
                  <div class="col-md-4 align-self-end">
                    <img src="@/assets/images/unicampo.jpg" height="100" />
                  </div>
                </div>
              </div>
              <div class="card-body pt-0">
                <div class="p-2">
                  <div
                    class="alert alert-success text-center mb-4"
                    role="alert"
                  >
                    Agora é só redefinir a sua nova senha
                  </div>

                  <div class="row">
                    <b-form-group
                      class="mb-3"
                      label="Nova senha"
                      invalid-feedback="Digite uma senha que atenda a todas as exigências"
                    >
                      <b-form-input
                        v-model="senhaNova"
                        :type="inputType"
                        @blur="verificarSenhaIgual()"
                        @keyup="verificarSenhaIgual()"
                        @input="verificarSenha(senhaNova)"
                        :state="validacaoSenha"
                        trim
                        style="width: 90% !important; display: unset"
                      >
                      </b-form-input>
                      <button
                        class="btn btn-light btn-outline-secondary"
                        type="button"
                        @click="togglePassword()"
                        tabindex="-1"
                      >
                        <i v-if="isPassword" class="mdi mdi-eye-outline"></i>
                        <i v-else class="mdi mdi-eye-off-outline"></i>
                      </button>
                    </b-form-group>
                    <div>
                      <p class="fst-italic text-danger" v-if="tamanhoSenha">
                        De 10 à 20 caracteres
                      </p>
                      <p class="fst-italic text-danger" v-if="minusculaSenha">
                        Letra minúscula
                      </p>
                      <p class="fst-italic text-danger" v-if="maiusculaSenha">
                        Letra maiúscula
                      </p>
                      <p class="fst-italic text-danger" v-if="numeroSenha">
                        Número
                      </p>
                      <p
                        class="fst-italic text-danger"
                        v-if="simbolosPermitidosSenha"
                      >
                      Símbolos obrigatórios ! ? ¨ - *
                      </p>
                      <p
                        class="fst-italic text-danger"
                        v-if="simbolosNaoPermitidosSenha"
                      >
                      Símbolos não permitidos: @, #, &, , /, +, %

                      </p>
                    </div>
                  </div>

                  <div class="row">
                    <b-form-group
                      class="mb-3"
                      label="Confirmação de senha *"
                      invalid-feedback="As senhas devem ser iguais e atender a todas as exigências."
                    >
                      <b-form-input
                        v-model="senhaConfirmacao"
                        @blur="verificarSenhaIgual()"
                        @keyup="verificarSenhaIgual()"
                        @paste="disablePaste"
                        :state="validacaoSenhaIgual"
                        :type="inputType"
                        trim
                        style="width: 90% !important; display: unset"
                      ></b-form-input>
                      <button
                        class="btn btn-light btn-outline-secondary"
                        type="button"
                        @click="togglePassword()"
                        tabindex="-1"
                      >
                        <i v-if="isPassword" class="mdi mdi-eye-outline"></i>
                        <i v-else class="mdi mdi-eye-off-outline"></i>
                      </button>
                    </b-form-group>
                  </div>

                  <div class="form-group row mb-0 mt-2">
                    <div class="col-12 text-end">
                      <button
                        class="btn btn-primary w-md"
                        @click="redefinir"
                        :disabled="disabledRedefinir"
                      >
                        Redefinir
                        <b-spinner
                          class="ms-2"
                          small
                          variant="secondary"
                          v-if="loadingRedefinir"
                        ></b-spinner>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-5 text-center">
              <p>
                Se lembrou?
                <router-link tag="a" to="/login" class="fw-medium text-primary"
                  >Faça o Login aqui</router-link
                >
              </p>
              <p>
                © {{ new Date().getFullYear() }} UNICAMPO. Todos os direitos
                reservados.
              </p>
            </div>
          </div>
        </div>
      </div>
      <vue-recaptcha
        sitekey="6LebGvweAAAAAFnTI7kT4HBEvkfpo-mDg-Ndfq2D"
        size="invisible"
        @verify="verifyMethod"
        ref="recaptcha"
      >
      </vue-recaptcha>
    </div>
  </div>
</template>

<script>
import appConfig from "@/app.config";
import { VueRecaptcha } from "vue-recaptcha";
import redefinirSenhaMixin from "@/tools/mixins/redefinirSenhaMixin.js";

export default {
  mixins: [redefinirSenhaMixin],
  components: { VueRecaptcha },
  data() {
    return {
      emailToken: "",
      senhaAtual: "",
      senhaNova: "",
      senhaConfirmacao: "",
      validacaoSenhaIgual: null,
      validacaoSenha: null,
      tamanhoSenha: true,
      minusculaSenha: true,
      maiusculaSenha: true,
      numeroSenha: true,
      simbolosPermitidosSenha: true,
      simbolosNaoPermitidosSenha: true,
      inputType: "password",
      loadingRedefinir: false,
      loading: true,
      sq_usuario: "",
      usuarioLogado: false,
    };
  },

  page: {
    title: "Redefinir Senha",
    //Revisar a necessidade desse meta
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },

  //Esconder o menu e o layout
  layout: "empty",

  async created() {
    const token = this.$route.params._id;
    if (token) {
      await this.validarTokenRedefinirSenha(token);
    } else {
      this.$router.push("/login");
    }
  },

  computed: {
    isPassword() {
      return this.inputType === "password";
    },

    //REVISAR LÓGICA da desabilitação do botão
    disabledRedefinir() {
      const senhaVazia = this.senhaAtual === "";
      const invalidaSenha =
        this.validacaoSenha !== true ||
        this.validacaoSenhaIgual !== true ||
        this.loadingRedefinir === true;
      if (this.UsuarioLogadoSistema) {
        return senhaVazia || invalidaSenha;
      }
      return invalidaSenha;
    },
  },

  methods: {
    async validarTokenRedefinirSenha(token) {
      try {
        const response = await this.$http.get(
          "api/auth/validarTokenRedefinirSenha/" + token
        );
        this.emailToken = token;
        this.sq_usuario = response.data.sq_usuario;
        this.loading = false;
      } catch (err) {
        this.$router.push("/login");
        this.$tools.alerta(err.response.data.message, "error");
      }
    },

    async redefinir() {
      this.loadingRedefinir = true;
      try {
        const redefinirSenha = await this.redefinirSenha();
        this.$tools.alerta(redefinirSenha.data.message, "success");
        this.$router.push("/login");
      } catch (err) {
        this.loadingRedefinir = false;
        this.$tools.alerta(err.response.data.message, "error");
      }
    },

    verifyMethod(token) {
      this.$http
        .get("api/auth/recaptcha/" + token)
        .then((response) => {
          if (response.data.success) {
            this.login();
          } else {
            this.$tools.alerta("Recaptcha Invalido", "error");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>